import { render, staticRenderFns } from "./JsonEditorIndex.vue?vue&type=template&id=440d52b8&scoped=true"
import script from "./JsonEditorIndex.vue?vue&type=script&lang=js"
export * from "./JsonEditorIndex.vue?vue&type=script&lang=js"
import style0 from "./JsonEditorIndex.vue?vue&type=style&index=0&id=440d52b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440d52b8",
  null
  
)

export default component.exports